(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-mix-match"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-mix-match')) {
    customElements.define('fh-mix-match', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const demo = this.querySelector('video');
        if (demo && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          let attempted = false;
          this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !attempted) { attempted = true; demo.play().catch(() => {}); }
              else if (!entry.isIntersecting) demo.pause();
            });
          }, {threshold: 0.45});
          this.videoObserver.observe(demo);
        }
        this.selection = {top: 0, bottom: 0};
        this.buttons = [...this.querySelectorAll('[data-part]')];
        this.buttons.forEach(button => {
          button.addEventListener('click', () => this.choose(button));
          button.addEventListener('dragstart', event => {
            this.dragged = button;
            event.dataTransfer.setData('text/plain', button.dataset.name);
            event.dataTransfer.effectAllowed = 'copy';
          });
          button.addEventListener('dragend', () => { this.dragged = null; this.zone.classList.remove('is-over'); });
        });
        this.zone = this.querySelector('[data-drop-zone]');
        this.zone.addEventListener('dragover', event => { if (this.dragged) { event.preventDefault(); event.dataTransfer.dropEffect = 'copy'; this.zone.classList.add('is-over'); } });
        this.zone.addEventListener('dragleave', event => { if (!this.zone.contains(event.relatedTarget)) this.zone.classList.remove('is-over'); });
        this.zone.addEventListener('drop', event => { if (this.dragged) { event.preventDefault(); this.choose(this.dragged); this.dragged = null; this.zone.classList.remove('is-over'); } });
      }
      disconnectedCallback() { if (this.videoObserver) { this.videoObserver.disconnect(); this.videoObserver = null; } }
      choose(button) {
        this.selection[button.dataset.part] = Number(button.dataset.index);
        const {top, bottom} = this.selection;
        this.buttons.forEach(b => b.setAttribute('aria-pressed', String(this.selection[b.dataset.part] === Number(b.dataset.index))));
        const topName = this.buttons.find(b => b.dataset.part === 'top' && Number(b.dataset.index) === top).dataset.name;
        const bottomName = this.buttons.find(b => b.dataset.part === 'bottom' && Number(b.dataset.index) === bottom).dataset.name;
        const visual = this.querySelector('[data-visual]');
        visual.style.setProperty('--row', top);
        visual.style.setProperty('--col', bottom);
        visual.setAttribute('aria-label', `${topName} + ${bottomName}`);
        this.querySelector('[data-count]').textContent = String(top * 3 + bottom + 1);
        this.querySelector('[data-top-name]').textContent = topName;
        this.querySelector('[data-bottom-name]').textContent = bottomName;
        this.querySelector('[data-need-one]').hidden = top !== bottom;
        this.querySelector('[data-need-two]').hidden = top === bottom;
        this.querySelector('[data-note-one]').hidden = top !== bottom;
        this.querySelector('[data-note-two]').hidden = top === bottom;
        this.querySelectorAll('[data-product-link]').forEach(a => { const i = Number(a.dataset.productLink); a.hidden = i !== top && i !== bottom; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
